import styled from '@emotion/styled'

export const Container = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  max-width: 1440px;
  padding: 2rem 0;
  width: 100%;

  @media (max-width: 768px) {
    padding: 2rem;
  }
`
